module.exports = __webpack_public_path__ + "static/D2-site-cases-original-sugar-free-2f0ef6e93efe5577780a1a7c2aa1acac.jpg";